enum VisibilityState {
    VISIBLE = 'visible',
    HIDDEN = 'hidden',
  }

export default VisibilityState;
